// src/pages/Home/components/CTASection.js
import React from 'react';
import { Button } from '../../../components/ui/button';
import { ArrowRight, Play, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-teal-600 via-indigo-600 to-purple-600 py-24">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.div
          className="absolute top-0 left-1/4 w-96 h-96 bg-teal-400 rounded-full mix-blend-multiply opacity-20 animate-pulse-slow"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1.2 }}
          transition={{ repeat: Infinity, duration: 10, ease: 'easeInOut' }}
        />
        <motion.div
          className="absolute -bottom-40 left-1/3 w-96 h-96 bg-indigo-500 rounded-full mix-blend-multiply opacity-20 animate-pulse-slow animation-delay-4000"
          initial={{ scale: 1 }}
          animate={{ scale: 1.3 }}
          transition={{ repeat: Infinity, duration: 12, ease: 'easeInOut', delay: 4 }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          {/* Main CTA content */}
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
          >
            Accelerate Your Incident Resolution by <span className="text-yellow-300">10x</span>
          </motion.h2>
          
          <motion.p
            className="text-xl text-blue-100 mb-12 leading-relaxed"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            Reduce downtime and save costs by swiftly identifying the root causes of production issues with DeltaOps.
          </motion.p>

          {/* CTA buttons */}
          <motion.div
            className="flex flex-col sm:flex-row justify-center gap-4"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.9 }}
          >
            <Button 
              size="lg"
              className="bg-white text-indigo-600 hover:bg-gray-100 text-lg px-8 h-14 shadow-lg hover:shadow-xl transition-all flex items-center justify-center"
              onClick={() => window.location.href = '/pricing'}
            >
              Get Started
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              variant="outline"
              size="lg"
              className="text-white border-white hover:bg-indigo-700 hover:border-indigo-700 hover:text-white text-lg px-8 h-14 flex items-center justify-center"
              onClick={() => window.location.href = '/#demo'}
            >
              Try Demo
              <Play className="ml-2 h-4 w-4" />
            </Button>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;
